import { cn, Label, RadioGroup, RadioGroupItem } from '@shigo-ui/ui';
import { useId } from 'react';

import { dashboardT } from '../../../../lib/messages';

const inclusionRadioClassName =
  'border-input h-[18px] w-[18px] border-2 text-[var(--shigo-highlight)] shadow-none data-[state=checked]:border-[var(--shigo-highlight)] [&_svg]:h-2.5 [&_svg]:w-2.5 [&_svg]:fill-[var(--shigo-highlight)]';

export function InclusionToggle({
  included,
  onIncludedChange,
}: {
  included: boolean;
  onIncludedChange: (included: boolean) => void;
}) {
  const includedId = useId();
  const excludedId = useId();

  return (
    <RadioGroup
      value={included ? 'included' : 'excluded'}
      className="flex flex-wrap items-center gap-4"
      onValueChange={(value) => {
        onIncludedChange(value === 'included');
      }}
    >
      <div className="flex items-center gap-2 text-sm" data-selected={included}>
        <RadioGroupItem id={includedId} value="included" className={inclusionRadioClassName} />
        <Label
          htmlFor={includedId}
          className={cn(
            'cursor-pointer text-sm transition-colors',
            included
              ? 'text-foreground font-medium'
              : 'text-muted-foreground hover:text-foreground font-normal',
          )}
        >
          {dashboardT('targeting.included')}
        </Label>
      </div>
      <div className="flex items-center gap-2 text-sm" data-selected={!included}>
        <RadioGroupItem id={excludedId} value="excluded" className={inclusionRadioClassName} />
        <Label
          htmlFor={excludedId}
          className={cn(
            'cursor-pointer text-sm transition-colors',
            included
              ? 'text-muted-foreground hover:text-foreground font-normal'
              : 'text-foreground font-medium',
          )}
        >
          {dashboardT('targeting.excluded')}
        </Label>
      </div>
    </RadioGroup>
  );
}
